export default {
    'ERRORS.ONLY.ONE.SLOT': 'Sorry! You cannot create more than one unavailability/reserved slot in the same day.',
    'ERRORS.PERMISSION': 'Sorry you do not have the permission to access',
    'ERRORS.LOGIN.PASSWORD': 'Name or password is incorrect. Please, try again.',
    'ERRORS.EVENT.PAST': 'Past events cannot be modified',
};
